import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { OkResponse } from './types/common'
import type {
	CreateRentalNoteBody,
	ListRentalNotesParams,
	ListRentalNotesResponse,
	RentalNote,
} from './types/rental'

export const rentalNotesApi = createApi({
	reducerPath: 'rentalNotesApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['RentalNote'],
	endpoints: (builder) => ({
		listRentalNotes: builder.query<ListRentalNotesResponse, ListRentalNotesParams>({
			query: ({ rentalId }) => `/rent/${rentalId}/notes`,
			providesTags: (_r, _e, { rentalId }) => [{ type: 'RentalNote', id: rentalId }],
		}),

		createRentalNote: builder.mutation<RentalNote | null, CreateRentalNoteBody>({
			query: ({ rentalId, ...body }) => ({
				url: `/rent/${rentalId}/notes`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (_r, _e, { rentalId }) => [{ type: 'RentalNote', id: rentalId }],
		}),

		deleteRentalNote: builder.mutation<OkResponse, { rentalId: string; noteId: string }>({
			query: ({ rentalId, noteId }) => ({
				url: `/rent/${rentalId}/notes/${noteId}`,
				method: 'DELETE',
			}),
			invalidatesTags: (_r, _e, { rentalId }) => [{ type: 'RentalNote', id: rentalId }],
		}),
	}),
})

export const {
	useListRentalNotesQuery,
	useCreateRentalNoteMutation,
	useDeleteRentalNoteMutation,
} = rentalNotesApi
